import type { CandidateResume } from '../types';
import { mockCandidateResume } from './mockCandidateResume';

export const candidateResumeMock: CandidateResume = mockCandidateResume();
